import React from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment/moment";
const { Tr, Th, Td, THead, TBody } = Table;

const mapApprovalStatus = (raw) => {// for status of the documents
  const s = (raw || "").toString().trim().toLowerCase();
  if (s === "approved") return "Approved";
  if (s === "client_approval_req") return "Client_approved_req";
  if (s === "client_approved_action") return "Client_approved_action";
  if (s === "admin_reject") return "Admin_reject";
  if (s === "client_reject") return "Client_reject";
  if (s === "pending") return "Pending";
  return "Pending";
};

const formatAmountInsured = (raw) => {
  if (raw === null || raw === undefined || raw === "") return "-";
  const s = String(raw).trim();
  if (!s || s === "-") return "-";

  const cleaned = s.replace(/[$,\s]/g, "");
  const n = Number(cleaned);
  if (!Number.isFinite(n)) return s.startsWith("$") ? s : `$${s}`;

  const formatted = n.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `$${formatted}`;
};

//  category mapping tried to re-bucket "Insurances" into "WHS/Info"
// based on doc_type_name. This diverged from Specific Provider -> Documents which follows
// common.document_types_category strictly.
// const groupDocsByCategory = (docs) => {
//   const safeDocs = Array.isArray(docs) ? docs : [];
//   const groups = new Map();
//   safeDocs.forEach((d) => {
//     const raw = (d?.doc_category || "").toString().trim();
//     const rawLower = raw.toLowerCase();
//     const typeRaw = (d?.doc_type_name || d?.doc_name || "").toString().trim();
//     const typeLower = typeRaw.toLowerCase();
//     const isNonInsuranceType =
//       typeLower === "whs" || typeLower === "info" || typeLower === "information";
//
//     const label =
//       rawLower === "licenses" || rawLower === "licences"
//         ? "Licenses"
//         : rawLower === "insurances" || rawLower === "insurance"
//           ? isNonInsuranceType
//             ? typeLower === "whs"
//               ? "WHS"
//               : "Info"
//             : "Insurances"
//           : rawLower === "whs"
//             ? "WHS"
//             : rawLower === "info" || rawLower === "information"
//               ? "Info"
//               : raw
//                 ? raw
//                 : "Others";
//
//     const arr = groups.get(label) || [];
//     arr.push(d);
//     groups.set(label, arr);
//   });
//
//   const coreOrder = ["Licenses", "Insurances", "WHS", "Info"];
//   const labels = Array.from(groups.keys());
//   const otherLabels = labels
//     .filter((l) => l !== "Others" && !coreOrder.includes(l))
//     .sort((a, b) => a.localeCompare(b));
//
//   const orderedLabels = [
//     ...coreOrder.filter((l) => groups.has(l)),
//     ...otherLabels,
//     ...(groups.has("Others") ? ["Others"] : []),
//   ];
//
//   return orderedLabels.map((label) => ({ label, rows: groups.get(label) || [] }));
// };

// NEW LOGIC: follow common.document_types_category (doc_category) like Specific Provider -> Documents.
// If doc_category is missing/blank, it belongs to "Others".
const groupDocsByCategory = (docs) => {
  const safeDocs = Array.isArray(docs) ? docs : [];
  const groups = new Map();

  const normalizeCategoryLabel = (raw) => {
    const s = (raw || "").toString().trim();
    if (!s) return "Others";
    const sl = s.toLowerCase();
    if (sl === "licenses" || sl === "licences") return "Licenses";
    if (sl === "insurances" || sl === "insurance") return "Insurances";
    if (sl === "whs") return "WHS";
    if (sl === "info" || sl === "information") return "Info";
    return s;
  };

  safeDocs.forEach((d) => {
    // Check if document has document_type_id 1 or 3 for Company Registration category
    if (d?.document_type_id === "1" || d?.document_type_id === "3" || d?.document_type_id === 1 || d?.document_type_id === 3) {
      const label = "Company Registration";
      const arr = groups.get(label) || [];
      arr.push(d);
      groups.set(label, arr);
    } else {
      const label = normalizeCategoryLabel(d?.doc_category);
      const arr = groups.get(label) || [];
      arr.push(d);
      groups.set(label, arr);
    }
  });

  const coreOrder = ["Licenses", "Insurances", "WHS", "Info", "Company Registration"];
  const labels = Array.from(groups.keys());
  const otherLabels = labels
    .filter((l) => l !== "Others" && !coreOrder.includes(l))
    .sort((a, b) => a.localeCompare(b));

  const orderedLabels = [
    ...coreOrder.filter((l) => groups.has(l)),
    ...otherLabels,
    ...(groups.has("Others") ? ["Others"] : []),
  ];

  return orderedLabels.map((label) => ({ label, rows: groups.get(label) || [] }));
};
const DataList = ({ data, handleSort, getAllinvitedData, buildRowKey, expandedRowKeys, onToggleExpand, rowDetailsMap, rowDetailsLoading, selectedRowKeys, onToggleRow, providerDocsByOrgId, providerDocsLoadingByOrgId }) => {
  const rows = Array.isArray(data?.DocsReport) ? data.DocsReport : [];

  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200 cstm-table">
        <Table>
          <THead>
            <Tr>
              <Th></Th>
              <Th></Th>
              <Th>Provider ID</Th>
              <Th>Provider Name</Th>
              <Th>ABN</Th>
              <Th>Checklist</Th>
              <Th>Client name</Th>
              <Th>Client Contact</Th>
              <Th>Client Contact Email</Th>
              <Th>Documents no.</Th>
              <Th>Completion rate</Th>
              <Th onClick={(e) => handleSort(e, "completion_date")}>
                <span className="flex items-center gap-1">
                  Completion date
                  <svg
                    className={`transform ${getAllinvitedData.sort === "completion_date" &&
                      getAllinvitedData.order === "asc"
                      ? "rotate-180"
                      : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
            </Tr>
          </THead>
          <TBody>

            {data?.DocsReport?.length > 0 &&
              data?.DocsReport?.map((item, index) => {
                const orgKey = item?.provider_org_id ?? item?.provider_id;
                const orgIdKey = orgKey !== null && orgKey !== undefined ? String(orgKey) : "";
                
                // FIX: Use context-based key instead of just provider ID to prevent caching collision
                // OLD: const cacheKey = orgIdKey; // This caused collision for same provider with different clients/checklists
                const contextKey = buildRowKey(item); // Use the same key as buildRowKey: provider|client|checklist
                
                const cachedDocs = contextKey && Array.isArray(providerDocsByOrgId?.[contextKey])
                  ? providerDocsByOrgId[contextKey]
                  : null;
                const reportDocs = Array.isArray(item?.documents) ? item.documents : [];
                
                // FIX: Use context-specific report docs first, then cached docs as fallback
                // This prevents document caching collision when same provider has different client/checklist combinations
                const docsArr = Array.isArray(reportDocs) ? reportDocs : cachedDocs;
                
                // "Documents no." should match Specific Provider -> Documents (OrgDocuments count),
                // not just checklist-assigned document types.
                const hasTotalProviderDocs =
                  item?.total_checklist_docs !== null &&
                  item?.total_checklist_docs !== undefined &&
                  item?.total_checklist_docs !== "";
                const documentsCount = hasTotalProviderDocs
                  ? Number(item?.total_checklist_docs)
                  : Array.isArray(docsArr)
                    ? docsArr.length
                    : 0;

                const providerStatusRaw = (item?.provider_status || "").toString().trim();
                const providerStatusNormalized = providerStatusRaw.toLowerCase();
                const providerStatusLabel =
                  providerStatusRaw === "Assigned"
                    ? "Registered"
                    : providerStatusRaw === "Registered"
                      ? "Self-Registered"
                      : providerStatusRaw === "No-clients"
                        ? "Self-Registered"
                        : providerStatusRaw === "Closed" || providerStatusRaw === "Inactive"
                          ? "Deactivated"
                          : providerStatusRaw || "-";
                const isMainRowRed = providerStatusLabel === "Non-Compliant";
                return (
                  <React.Fragment key={index}>
                    <Tr className={isMainRowRed ? "!text-red-600 font-medium" : "text-gray-800"}>
                      <Td>
                        <input
                          type="checkbox"
                          checked={selectedRowKeys?.has(buildRowKey(item))}
                          onChange={() => onToggleRow(item)}
                        />
                      </Td>
                      <Td>
                        <button
                          type="button"
                          onClick={() => onToggleExpand(item)}
                          className="flex items-center"
                          aria-label="Expand row"
                        >
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className={`${expandedRowKeys?.has(buildRowKey(item)) ? "transform rotate-180" : ""}`}
                            aria-hidden="true"
                          >
                            <path
                              d="M6 9l6 6 6-6"
                              stroke="#475467"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </Td>
                      <Td>{item?.provider_org_id || "-"}</Td>
                      <Td>{item?.provider_trading_name}</Td>
                      <Td>{item?.provider_abn_nzbn || "-"}</Td>
                      <Td>{item?.checklist_name}</Td>
                      <Td>{item?.client_trading_name}</Td>
                      <Td>{item?.client_contact || "-"}</Td>
                      <Td>{item?.client_contact_email || "-"}</Td>
                      <Td>{documentsCount}</Td>
                      <Td className={"flex items-center gap-1	"}>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                          <div
                            className="bg-blue-600 h-2.5 rounded-full"
                            style={{
                              width: `${Number(item?.completion_rate)?.toFixed(
                                2
                              )}%`,
                            }}
                          ></div>
                        </div>
                        {`${Number(item?.completion_rate)?.toFixed(2)}%`}
                      </Td>
                      <Td>
                        {item?.completion_date
                          ? moment(item?.completion_date).format("DD/MM/YYYY")
                          : "-"}
                      </Td>
                    </Tr>

                    {expandedRowKeys?.has(buildRowKey(item)) ? (
                      <Tr key={`details-${index}`}>
                        <Td colSpan={14}>
                          <div className="p-3 bg-gray-50 rounded">
                            {(() => {
                              // FIX: Use context-based key for loading state instead of just provider ID
                              const isLoading = contextKey ? Boolean(providerDocsLoadingByOrgId?.[contextKey]) : false;
                              const reportDocs = Array.isArray(item?.documents) ? item.documents : [];
                              
                              const providerDocs = Array.isArray(cachedDocs) ? cachedDocs : [];
                              const hasProviderDocs = providerDocs.length > 0;
                              const isProviderDocsLoadedForThisRow = contextKey
                                ? Array.isArray(providerDocsByOrgId?.[contextKey])
                                : false;

                              // OLD LOGIC (preserved): merged providerDocs + missing checklist docs, which could repeat rows.
                              // const hasReportDocs = Array.isArray(reportDocs) && reportDocs.length > 0;
                              // let docsRaw = [];
                              // if (hasProviderDocs) {
                              //   if (hasReportDocs) {
                              //     const providerDocIds = new Set(
                              //       providerDocs
                              //         .filter((d) => d?.document_id !== null && d?.document_id !== undefined)
                              //         .map((d) => String(d.document_id))
                              //     );
                              //     const missingChecklistDocs = reportDocs.filter((d) => {
                              //       const id = d?.document_id;
                              //       if (id === null || id === undefined || id === "") return true;
                              //       return !providerDocIds.has(String(id));
                              //     });
                              //     docsRaw = [...providerDocs, ...missingChecklistDocs];
                              //   } else {
                              //     docsRaw = providerDocs;
                              //   }
                              // } else if (hasReportDocs) {
                              //   docsRaw = reportDocs;
                              // }

                              // Use report docs only (they have is_waived flag properly set)
                              // Do not use provider docs as they don't have is_waived flag
                              // Filter out checklist expectations that have not been uploaded yet
                              const docsRaw = (reportDocs || []).filter((d) => d?.provider_doc_appr_id || d?.document_id);

                              const reportByDocumentId = new Map(
                                reportDocs
                                  .filter((d) => d?.document_id !== null && d?.document_id !== undefined)
                                  .map((d) => [String(d.document_id), d])
                              );

                              const fallbackDocs = Array.isArray(cachedDocs) ? cachedDocs : [];
                              const fallbackByDocumentId = new Map(
                                fallbackDocs
                                  .filter((d) => d?.document_id !== null && d?.document_id !== undefined)
                                  .map((d) => [String(d.document_id), d])
                              );
                              const fallbackByDocTypeId = new Map();
                              fallbackDocs.forEach((d) => {
                                const key = d?.document_type_id !== null && d?.document_type_id !== undefined
                                  ? String(d.document_type_id)
                                  : "";
                                if (key && !fallbackByDocTypeId.has(key)) {
                                  fallbackByDocTypeId.set(key, d);
                                }
                              });

                              const dedupeDocs = (arr) => {
                                const safe = Array.isArray(arr) ? arr : [];
                                const seen = new Set();
                                return safe.filter((d) => {
                                  const id =
                                    d?.org_document_id ??
                                    d?.document_id ??
                                    null;
                                  const key = id !== null && id !== undefined && id !== ""
                                    ? String(id)
                                    : `${(d?.doc_type_name || "").toString().trim().toLowerCase()}|${(d?.doc_name || d?.other_doc_name || "").toString().trim().toLowerCase()}|${(d?.expiry_date || "").toString().trim()}`;
                                  if (seen.has(key)) return false;
                                  seen.add(key);
                                  return true;
                                });
                              };

                              // OLD LOGIC (preserved): mapped docsRaw directly (could include repeats).
                              // const docs = (docsRaw || []).map((d) => {
                              //   ...
                              // });

                              const docs = dedupeDocs(docsRaw || [])
                                .filter((d) => !d?.is_waived)
                                .map((d) => {
                                const key = d?.document_id !== null && d?.document_id !== undefined ? String(d.document_id) : "";
                                const r = key ? reportByDocumentId.get(key) : null;
                                const typeKey = d?.document_type_id !== null && d?.document_type_id !== undefined
                                  ? String(d.document_type_id)
                                  : "";
                                const fallback =
                                  (key && fallbackByDocumentId.get(key)) ||
                                  (!d?.is_other_doc && typeKey && fallbackByDocTypeId.get(typeKey)) ||
                                  null;

                                return {
                                  ...d,
                                  // Keep approval state checklist-specific (provider_org_id + client_org_id + checklist_doc_id).
                                  // Provider-level docs can be approved for a different client; don't borrow approval status.
                                  approval_status:
                                    r?.approval_status !== null && r?.approval_status !== undefined
                                      ? r.approval_status
                                      : d?.approval_status !== null && d?.approval_status !== undefined
                                        ? d.approval_status
                                        : "pending",
                                  reviewed_date:
                                    r?.reviewed_date !== null && r?.reviewed_date !== undefined
                                      ? r.reviewed_date
                                      : d?.reviewed_date !== null && d?.reviewed_date !== undefined
                                        ? d.reviewed_date
                                        : null,
                                  doc_name:
                                    d?.doc_name !== null && d?.doc_name !== undefined
                                      ? d.doc_name
                                      : fallback?.doc_name !== null && fallback?.doc_name !== undefined
                                        ? fallback.doc_name
                                        : r?.doc_name !== null && r?.doc_name !== undefined
                                          ? r.doc_name
                                          : null,
                                  doc_type_name:
                                    d?.doc_type_name !== null && d?.doc_type_name !== undefined
                                      ? d.doc_type_name
                                      : fallback?.doc_type_name !== null && fallback?.doc_type_name !== undefined
                                        ? fallback.doc_type_name
                                        : r?.doc_type_name !== null && r?.doc_type_name !== undefined
                                          ? r.doc_type_name
                                          : null,
                                  doc_category:
                                    d?.doc_category !== null && d?.doc_category !== undefined
                                      ? d.doc_category
                                      : fallback?.doc_category !== null && fallback?.doc_category !== undefined
                                        ? fallback.doc_category
                                        : r?.doc_category !== null && r?.doc_category !== undefined
                                          ? r.doc_category
                                          : null,
                                  issuing_authority:
                                    d?.issuing_authority !== null && d?.issuing_authority !== undefined
                                      ? d.issuing_authority
                                      : fallback?.issuing_authority !== null && fallback?.issuing_authority !== undefined
                                        ? fallback.issuing_authority
                                        : fallback?.issuer !== null && fallback?.issuer !== undefined
                                          ? fallback.issuer
                                          : r?.issuing_authority !== null && r?.issuing_authority !== undefined
                                            ? r.issuing_authority
                                            : null,
                                  policy_no:
                                    d?.policy_no !== null && d?.policy_no !== undefined
                                      ? d.policy_no
                                      : fallback?.policy_no !== null && fallback?.policy_no !== undefined
                                        ? fallback.policy_no
                                        : r?.policy_no !== null && r?.policy_no !== undefined
                                          ? r.policy_no
                                          : null,
                                  amount_insured:
                                    d?.amount_insured !== null && d?.amount_insured !== undefined
                                      ? d.amount_insured
                                      : fallback?.amount_insured !== null && fallback?.amount_insured !== undefined
                                        ? fallback.amount_insured
                                        : r?.amount_insured !== null && r?.amount_insured !== undefined
                                          ? r.amount_insured
                                          : null,
                                  expiry_date:
                                    d?.expiry_date !== null && d?.expiry_date !== undefined
                                      ? d.expiry_date
                                      : fallback?.expiry_date !== null && fallback?.expiry_date !== undefined
                                        ? fallback.expiry_date
                                        : r?.expiry_date !== null && r?.expiry_date !== undefined
                                          ? r.expiry_date
                                          : null,
                                  // doc_expiry_date is approval-specific; don't borrow across clients.
                                  doc_expiry_date:
                                    r?.doc_expiry_date !== null && r?.doc_expiry_date !== undefined
                                      ? r.doc_expiry_date
                                      : d?.doc_expiry_date !== null && d?.doc_expiry_date !== undefined
                                        ? d.doc_expiry_date
                                        : null,
                                  doctype_fields_data:
                                    d?.doctype_fields_data !== null && d?.doctype_fields_data !== undefined
                                      ? d.doctype_fields_data
                                      : fallback?.doctype_fields_data !== null && fallback?.doctype_fields_data !== undefined
                                        ? fallback.doctype_fields_data
                                        : r?.doctype_fields_data !== null && r?.doctype_fields_data !== undefined
                                          ? r.doctype_fields_data
                                          : null,
                                };
                              });
                              if (isLoading || !isProviderDocsLoadedForThisRow) {
                                return <div className="text-sm text-gray-500">Loading documents...</div>;
                              }
                              if (!docs.length) {
                                return <div className="text-sm text-gray-500">No documents to display.</div>;
                              }

                              const grouped = groupDocsByCategory(docs);
                              const renderStatusCell = (doc) => {
                                const labelStatus = mapApprovalStatus(doc?.approval_status);
                                const badgeClass =
                                  labelStatus === "Approved"
                                    ? "badge bg-success-50 text-success-700 py-0.5 px-2 rounded-lg font-medium"
                                    : labelStatus === "Client_approved_req"
                                      ? "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                                      : labelStatus === "Client_approved_action"
                                        ? "badge bg-blue-50 text-blue-800 py-0.5 px-2 rounded-lg font-normal"
                                        : labelStatus === "Admin_reject"
                                          ? "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                                          : labelStatus === "Client_reject"
                                            ? "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                                            : labelStatus === "Pending"
                                              ? "badge text-gray-700 bg-gray-100 py-0.5 px-2 rounded-lg font-normal"
                                              : "badge bg-gray-100 text-gray-700 py-0.5 px-2 rounded-lg font-normal";

                                return (
                                  <span className={badgeClass}>{labelStatus}</span>
                                );
                              };

                              const getDocExpiry = (doc) => {
                                const exp = doc?.doc_expiry_date ?? doc?.expiry_date ?? null;
                                if (exp === "-" || exp === "" || exp === undefined) return null;
                                return exp;
                              };

                              const getIssuingAuthority = (doc) => {
                                const direct = doc?.issuing_authority || doc?.issuer;
                                if (direct && String(direct).trim()) return String(direct).trim();

                                const fields = doc?.doctype_fields_data;
                                const fromJson =
                                  fields?.Issuer ||
                                  fields?.issuer ||
                                  fields?.issuing_authority ||
                                  fields?.issuingAuthority;

                                if (fromJson && String(fromJson).trim()) {
                                  return String(fromJson).trim();
                                }

                                return "-";
                              };


                              const getIssueDate = (doc) => {
                                const fieldsRaw = doc?.doctype_fields_data;
                                const fields =
                                  typeof fieldsRaw === "string"
                                    ? (() => {
                                        try {
                                          return JSON.parse(fieldsRaw);
                                        } catch (e) {
                                          return {};
                                        }
                                      })()
                                    : (fieldsRaw || {});
                                const issueFromFields =
                                  fields?.issuedate ||
                                  fields?.IssueDate ||
                                  fields?.issueDate ||
                                  fields?.issue_date ||
                                  fields?.Issue_Date ||
                                  fields?.valid_from ||
                                  fields?.ValidFrom ||
                                  fields?.validFrom;
                                return issueFromFields || doc?.issue_date || null;
                              };

                              const renderSection = (title, cols, rows) => {
                                if (!rows?.length) return null;

                                const sharedColClasses = {
                                  docName: "w-80",
                                  docType: "w-56",
                                  issuingAuthority: "w-56",
                                  issueDate: "w-36",
                                  policyNo: "w-40",
                                  amountInsured: "w-40",
                                  expiry: "w-36",
                                };

                                const buildColGroup = () => {
                                  if (title === "Licenses") {
                                    return (
                                      <colgroup>
                                        <col className={sharedColClasses.docName} />
                                        <col className={sharedColClasses.docType} />
                                        <col className={sharedColClasses.issuingAuthority} />
                                        <col className={sharedColClasses.issueDate} />
                                        <col className={sharedColClasses.expiry} />
                                      </colgroup>
                                    );
                                  }
                                  if (title === "Insurances") {
                                    return (
                                      <colgroup>
                                        <col className={sharedColClasses.docName} />
                                        <col className={sharedColClasses.docType} />
                                        <col className={sharedColClasses.issuingAuthority} />
                                        <col className={sharedColClasses.issueDate} />
                                        <col className={sharedColClasses.policyNo} />
                                        <col className={sharedColClasses.amountInsured} />
                                        <col className={sharedColClasses.expiry} />
                                      </colgroup>
                                    );
                                  }
                                  if (title === "WHS") {
                                    return (
                                      <colgroup>
                                        <col className={sharedColClasses.docName} />
                                        <col className={sharedColClasses.docType} />
                                        <col className={sharedColClasses.issuingAuthority} />
                                        <col className={sharedColClasses.issueDate} />
                                        <col className={sharedColClasses.expiry} />
                                      </colgroup>
                                    );
                                  }
                                  if (title === "Company Registration") {
                                    return (
                                      <colgroup>
                                        <col className={sharedColClasses.docName} />
                                        <col className={sharedColClasses.docType} />
                                        <col className={sharedColClasses.issuingAuthority} />
                                        <col className={sharedColClasses.issueDate} />
                                        <col className={sharedColClasses.expiry} />
                                      </colgroup>
                                    );
                                  }
                                  return (
                                    <colgroup>
                                      <col className={sharedColClasses.docName} />
                                      <col className={sharedColClasses.docType} />
                                      <col className={sharedColClasses.issuingAuthority} />
                                      <col className={sharedColClasses.issueDate} />
                                      <col className={sharedColClasses.expiry} />
                                    </colgroup>
                                  );
                                };

                                return (
                                  <div className="mb-4">
                                    <div className="font-semibold text-gray-900 mb-2">{title}</div>
                                    <div className="overflow-x-auto">
                                      <table className="min-w-full text-sm table-fixed">
                                        {buildColGroup()}
                                        <thead>
                                          <tr className="text-left text-gray-600">
                                            {cols.map((c) => (
                                              <th key={c} className="py-1 pr-4 whitespace-nowrap">{c}</th>
                                            ))}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {rows.map((doc, i) => {
                                            const expiryDate = getDocExpiry(doc);
                                            const isExpired = expiryDate && moment(expiryDate).isValid() && moment(expiryDate).isBefore(moment(), "day");
                                            const cellStyle = isExpired ? { color: "#dc2626", fontWeight: "600" } : {};

                                            return (
                                              <tr key={`${title}-${i}`}>
                                                {title === "Licenses" ? (
                                                  <>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{doc?.doc_name || (doc?.is_other_doc ? (doc?.other_doc_name || "-") : "-")}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{doc?.doc_type_name || "-"}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{getIssuingAuthority(doc)}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 whitespace-nowrap">{getIssueDate(doc) ? moment(getIssueDate(doc)).format("DD/MM/YYYY") : "-"}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 whitespace-nowrap">{(() => {
                                                      const exp = getDocExpiry(doc);
                                                      if (!exp) return "Never";
                                                      const formatted = moment(exp).format("DD/MM/YYYY");
                                                      return formatted === "31/12/2099" ? "Never" : formatted;
                                                    })()}</td>
                                                  </>
                                                ) : title === "Insurances" ? (
                                                  <>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{doc?.doc_name || (doc?.is_other_doc ? (doc?.other_doc_name || "-") : "-")}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{doc?.doc_type_name || "-"}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{getIssuingAuthority(doc)}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 whitespace-nowrap">{getIssueDate(doc) ? moment(getIssueDate(doc)).format("DD/MM/YYYY") : "-"}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{doc?.policy_no || "-"}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 whitespace-nowrap">
                                                      {formatAmountInsured(doc?.amount_insured)}
                                                    </td>
                                                    <td style={cellStyle} className="py-1 pr-4 whitespace-nowrap">{(() => {
                                                      const exp = getDocExpiry(doc);
                                                      if (!exp) return "Never";
                                                      const formatted = moment(exp).format("DD/MM/YYYY");
                                                      return formatted === "31/12/2099" ? "Never" : formatted;
                                                    })()}</td>
                                                  </>
                                                ) : title === "WHS" ? (
                                                  <>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{doc?.doc_name || (doc?.is_other_doc ? (doc?.other_doc_name || "-") : "-")}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{doc?.doc_type_name || "-"}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{getIssuingAuthority(doc)}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 whitespace-nowrap">{getIssueDate(doc) ? moment(getIssueDate(doc)).format("DD/MM/YYYY") : "-"}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 whitespace-nowrap">{(() => {
                                                      const exp = getDocExpiry(doc);
                                                      if (!exp) return "Never";
                                                      const formatted = moment(exp).format("DD/MM/YYYY");
                                                      return formatted === "31/12/2099" ? "Never" : formatted;
                                                    })()}</td>
                                                  </>
                                                ) : title === "Company Registration" ? (
                                                  <>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{doc?.doc_name || (doc?.is_other_doc ? (doc?.other_doc_name || "-") : "-")}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{doc?.doc_type_name || "-"}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{getIssuingAuthority(doc)}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 whitespace-nowrap">{getIssueDate(doc) ? moment(getIssueDate(doc)).format("DD/MM/YYYY") : "-"}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 whitespace-nowrap">{(() => {
                                                      const exp = getDocExpiry(doc);
                                                      if (!exp) return "Never";
                                                      const formatted = moment(exp).format("DD/MM/YYYY");
                                                      return formatted === "31/12/2099" ? "Never" : formatted;
                                                    })()}</td>
                                                  </>
                                                ) : (
                                                  <>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{doc?.doc_name || (doc?.is_other_doc ? (doc?.other_doc_name || "-") : "-")}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{doc?.doc_type_name || "-"}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 truncate">{getIssuingAuthority(doc)}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 whitespace-nowrap">{getIssueDate(doc) ? moment(getIssueDate(doc)).format("DD/MM/YYYY") : "-"}</td>
                                                    <td style={cellStyle} className="py-1 pr-4 whitespace-nowrap">{(() => {
                                                      const exp = getDocExpiry(doc);
                                                      if (!exp) return "Never";
                                                      const formatted = moment(exp).format("DD/MM/YYYY");
                                                      return formatted === "31/12/2099" ? "Never" : formatted;
                                                    })()}</td>
                                                  </>
                                                )}
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                );
                              };

                              return (
                                <>
                                  {grouped.map((g) => {
                                    const title = g.label;
                                    const rows = g.rows;

                                    const cols =
                                      title === "Licenses"
                                        ? ["Document Name", "Document Type", "Issuing Authority", "Issue date", "Expiry Date"]
                                        : title === "Insurances"
                                          ? ["Document Name", "Insurances Type", "Issuing Authority", "Issue date", "Policy number", "Amount Insured", "Expiry date"]
                                          : title === "WHS"
                                            ? ["Document Name", "Document Type", "Issuing Authority", "Issue date", "Expiry date"]
                                            : title === "Company Registration"
                                              ? ["Document Name", "Document Type", "Issuing Authority", "Issue date", "Expiry date"]
                                              : ["Document Name", "Document Type", "Issuing Authority", "Issue date", "Expiry date"];

                                    return renderSection(title, cols, rows);
                                  })}
                                  {!grouped.length ? (
                                    <div className="text-sm text-gray-500">No documents to display.</div>
                                  ) : null}
                                </>
                              );
                            })()}
                          </div>
                        </Td>
                      </Tr>
                    ) : null}

                  </React.Fragment>
                );
              })}

          </TBody>
        </Table>
      </div>
    </React.Fragment >
  );
};
export default DataList;
